import _ from 'lodash'

export function toArray<T = any>(maybeArr: T | T[]): T[] {
    return ([] as T[]).concat(maybeArr)
}

export function asArray<T>(possiblyArray: T | T[]): T[] {
    return _.isArray(possiblyArray) ? possiblyArray : [possiblyArray]
}
